/**
 * e-Auth Identific
 * This is a authenticator services using digital certificates to authenticate users. Version 2
 *
 * OpenAPI spec version: v2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {
  HttpClient, HttpParams
} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../../util/codecs/encoder';

import {Observable} from 'rxjs';
import {environment} from "../../../../../environments/environment";
import {ApiService} from "../../util/api.service";
import {HeadersRequest} from "../../util/model/header-request.inteface";


@Injectable()
export class AuthService {

  private basePath = environment.basePathEauthIdentific;

  constructor(protected apiService: ApiService, @Optional() @Inject('basePath') basePath: string, private http: HttpClient) {
    if (basePath) {
      this.basePath = basePath;
    }
  }

  /**
   * Validate credential and get user data
   *
   * @param token token
   * @param credential credential
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public decodeResponseUsingGET(token: string, credential: string): Observable<any> {
    if (token === null || token === undefined) {
      throw new Error('Required parameter token was null or undefined when calling decodeResponseUsingGET.');
    }
    if (credential === null || credential === undefined) {
      throw new Error('Required parameter credential was null or undefined when calling decodeResponseUsingGET.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (token !== undefined) {
      queryParameters = queryParameters.set('token', <any>token);
    }
    if (credential !== undefined) {
      queryParameters = queryParameters.set('credential', <any>credential);
    }

    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + environment.identificApiKey});
    const uri: string = environment.identific.decodeResponseUsingGET;

    return this.apiService.get<any>(this.basePath + uri, queryParameters, headers);


  }

  /**
   * Generate token
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateTokenUsingGET(): Observable<string> {

    const uri: string = environment.identific.generateTokenUsingGET;


    return this.http.get(this.basePath + uri, {
      headers: {
        'Authorization': `Bearer ${environment.identificApiKey}`
      },
      responseType: 'text',
    });


  }


}
